import StatesSelect from './StatesSelect';

export default StatesSelect;
